import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import { useTitle } from '@/shared/hooks/useTitle';
import StatusList from './status/status-list.component.vue';

type ReactiveData = {
  tabs: 'tab-1' | 'tab-2';
};

export default defineComponent({
  components: { StatusList },
  setup() {
    const { setTitle } = useTitle();

    const state = reactive<ReactiveData>({
      tabs: 'tab-1',
    });

    onMounted(async () => {
      setTitle({ title: '対応状況', icon: 'mdi-format-list-bulleted' });
    });

    return {
      state,
    };
  },
});
